module.exports = __webpack_public_path__ + "static/media/PHONE-MOCKUP-1_old2.d3da2324.png";